// ============================================================
// Dashboard module manifest — R3 retrofit (2026-04-24).
//
// The biggest design lift in R3: dashboard transitions from a
// hardcoded "5 KPIs + 2 lists" layout to MANIFEST-DRIVEN widget
// composition. This module owns the chrome (KPI strip + 2-col +
// HR-block frames) and a discovery loop that:
//
//   1. asks registry.getDashboardWidgetsFor(enabledModules, role)
//      for every widget the user is entitled to see;
//   2. groups them by widget.section ('kpi' / 'left-col' /
//      'right-col' / 'hr-block');
//   3. dynamic-imports each contributing module's index.js
//      (already cached by registry.loadEnabledModules at boot);
//   4. resolves the widget's mount fn by id (e.g. widget id
//      'inventory-low-stock-kpi' -> exported `mountInventoryLowStockKpiWidget`);
//   5. mounts each widget into a per-widget container, asynchronously
//      (per design-debate synthesis: chrome renders sync, widgets fill
//      in as imports resolve — keeps TTI under 1s).
//
// Dependencies: NONE. Dashboard reads from every other module via
// the registry contract — it does NOT static-import any module.
// (Hard-coded `dependencies: []` here is the explicit contract:
//  dashboard works with whatever modules are enabled.)
// ============================================================

export default {
  id:          'dashboard',
  name:        'Dashboard',
  version:     '1.0.0',
  description: 'Manifest-driven landing screen — composes widgets from every enabled module.',

  load: () => import('./index.js'),

  routes: [
    {
      id:       'dashboard',
      label:    'Dashboard',
      icon:     '🏠',
      section:  'main',
      sidebarPosition: 10,
      // 2026-05-04 sidebar-leak fix — gate on `dashboard.read`. Every role
      // (including staff) gets this in every industry pack. Director's '*'
      // fast-path also covers it. Per-widget gating happens via the
      // dashboardWidgets[].defaultRoles map (see permissions.js).
      visible:  (role, hasPerm) => hasPerm('dashboard.read'),
      mount:    'mountDashboard',
      unmount:  'unmountDashboard'
    }
  ],

  // No collections of its own — dashboard reads via contributing modules.
  schemas: [],

  permissions: [
    'dashboard.read'   // see the dashboard at all (everyone)
  ],

  dependencies: [],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  functions: [],

  dashboardWidgets: []   // dashboard does NOT contribute its own widgets — that would be circular.
};
